import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const LanguageSwitcher: React.FC = () => {
  const { currentLanguage, changeLanguage, isLoading } = useLanguage();

  const handleLanguageChange = async (lang: 'en' | 'id') => {
    if (lang !== currentLanguage && !isLoading) {
      await changeLanguage(lang);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      gap: '4px',
      background: '#f3f4f6',
      padding: '4px',
      borderRadius: '8px',
      border: '1px solid #d1d5db'
    }}>
      <button
        onClick={() => handleLanguageChange('en')}
        disabled={isLoading}
        style={{
          background: currentLanguage === 'en' ? '#3b82f6' : 'transparent',
          color: currentLanguage === 'en' ? 'white' : '#6b7280',
          border: 'none',
          padding: '6px 12px',
          borderRadius: '4px',
          cursor: isLoading ? 'not-allowed' : 'pointer',
          fontSize: '12px',
          fontWeight: '500',
          transition: 'all 0.2s',
          opacity: isLoading ? 0.6 : 1
        }}
        title="English"
      >
        🇺🇸 EN
      </button>
      <button
        onClick={() => handleLanguageChange('id')}
        disabled={isLoading}
        style={{
          background: currentLanguage === 'id' ? '#3b82f6' : 'transparent',
          color: currentLanguage === 'id' ? 'white' : '#6b7280',
          border: 'none',
          padding: '6px 12px',
          borderRadius: '4px',
          cursor: isLoading ? 'not-allowed' : 'pointer',
          fontSize: '12px',
          fontWeight: '500',
          transition: 'all 0.2s',
          opacity: isLoading ? 0.6 : 1
        }}
        title="Bahasa Indonesia"
      >
        🇮🇩 ID
      </button>
      {isLoading && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          marginLeft: '8px'
        }}>
          <div style={{
            width: '12px',
            height: '12px',
            border: '2px solid #d1d5db',
            borderTop: '2px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
        </div>
      )}
    </div>
  );
};
